// Interchangeable looks, so different free packs can be tried in the same city.
// All packs are CC0; see ASSET_LICENSES.md for sources.

export const BUILDING_STYLES = {
  quaternius: {
    label: "Brick downtown · Quaternius",
    turn: 0,
    models: [] as string[], // uses the layout's own Quaternius buildings
  },
  kenney: {
    label: "Colourful city · Kenney",
    turn: Math.PI, // fronts face -z in the files
    models: [
      ...["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n"].map((c) => `kenney-city/building-${c}.glb`),
      ...["a", "b", "c", "d", "e"].map((c) => `kenney-city/building-skyscraper-${c}.glb`),
    ],
  },
  kaykit: {
    label: "Toy town · KayKit",
    turn: 0,
    models: ["A", "B", "C", "D", "E", "F", "G", "H"].map((c) => `kaykit-city/building_${c}_withoutBase.gltf`),
  },
} as const;
export type BuildingStyle = keyof typeof BUILDING_STYLES;

export const VEHICLE_STYLES = {
  kenney: {
    label: "Cars · Kenney",
    turn: 0, // fronts face +z in the files (checked in screenshots)
    scale: 1.7,
    models: ["sedan", "sedan-sports", "hatchback-sports", "suv", "suv-luxury", "taxi", "police", "van", "delivery", "truck", "ambulance", "firetruck", "garbage-truck"].map((c) => `kenney-cars/${c}.glb`),
  },
  kaykit: {
    label: "Cars · KayKit",
    turn: 0,
    scale: 4.8,
    models: ["car_hatchback", "car_police", "car_sedan", "car_stationwagon", "car_taxi"].map((c) => `kaykit-city/${c}.gltf`),
  },
} as const;
export type VehicleStyle = keyof typeof VEHICLE_STYLES;
